import React from "react";
import styled, { keyframes } from "styled-components";

const ImageTicker = ({ images }) => {
  return (
    <TickerContainer>
      <TickerInner>
        {images.map((image, index) => (
          <TickerImage key={index} src={image} alt={`image-${index}`} />
        ))}
        {images.map((image, index) => (
          <TickerImage
            key={`duplicate-${index}`}
            src={image}
            alt={`image-${index}`}
          />
        ))}
      </TickerInner>
    </TickerContainer>
  );
};

const scrollAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const TickerContainer = styled.div`
  overflow: hidden;
  white-space: nowrap;
  padding: 24px 0;
`;

const TickerInner = styled.div`
  display: inline-flex;
  animation: ${scrollAnimation} 60s linear infinite;
`;

const TickerImage = styled.img`
  margin-right: 100px;
  width: auto; // or a specific width like '200px'
  height: auto; // This ensures the height scales to maintain the aspect ratio
  object-fit: contain; // This ensures the image will scale to fit the area, adjusting based on its aspect ratio
`;

export default ImageTicker;
